var _excluded = ["component", "href", "text", "kind", "icon", "iconPlacement", "size", "onClick", "className", "processingText", "isProcessing", "isDisabled", "type", "margin", "style"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classnames from 'classnames';
import { Icon } from '../../atoms/Icon/index';

/**
 * Status: *finished*.
 * Category: Buttons
 */
var Button = function Button(props) {
  var _classnames;

  var _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      href = props.href,
      text = props.text,
      kind = props.kind,
      icon = props.icon,
      _props$iconPlacement = props.iconPlacement,
      iconPlacement = _props$iconPlacement === void 0 ? 'left' : _props$iconPlacement,
      size = props.size,
      onClick = props.onClick,
      className = props.className,
      processingText = props.processingText,
      isProcessing = props.isProcessing,
      isDisabled = props.isDisabled,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      margin = props.margin,
      style = props.style,
      rest = _objectWithoutProperties(props, _excluded);

  var Tag = component === 'link' ? 'a' : component;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: classnames('button', (_classnames = {}, _defineProperty(_classnames, "button--".concat(kind), !isDisabled && kind), _defineProperty(_classnames, "button--".concat(size), size), _defineProperty(_classnames, "button--margin-".concat(margin), margin), _defineProperty(_classnames, 'button--processing', isProcessing), _defineProperty(_classnames, 'button--disabled', isDisabled), _classnames), className ? className : undefined),
    href: href ? href : undefined,
    onClick: onClick,
    disabled: isProcessing || isDisabled,
    type: type,
    style: style
  }, rest), icon && iconPlacement === 'left' && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    style: {
      fill: 'currentColor',
      height: '20px',
      marginBottom: '-8px',
      marginLeft: '-6px',
      marginRight: '10px',
      position: 'relative',
      top: '-3.5px',
      width: '20px'
    }
  }), !isProcessing && text, isProcessing && /*#__PURE__*/React.createElement("span", {
    className: "button__processing"
  }, processingText, /*#__PURE__*/React.createElement("span", {
    className: "button__processing-dot"
  }, "."), /*#__PURE__*/React.createElement("span", {
    className: "button__processing-dot"
  }, "."), /*#__PURE__*/React.createElement("span", {
    className: "button__processing-dot"
  }, ".")), icon && iconPlacement === 'right' && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    style: {
      fill: 'currentColor',
      height: '20px',
      marginBottom: '-8px',
      marginLeft: '10px',
      marginRight: '-6px',
      position: 'relative',
      top: '-3.5px',
      width: '20px'
    }
  }));
};

export default Button;
Button.types = {
  button: 'button',
  reset: 'reset',
  submit: 'submit'
};
Button.kinds = {
  normal: 'normal',
  primary: 'primary',
  cancel: 'cancel',
  link: 'link',
  secondLink: 'secondLink',
  inverted: 'inverted',
  negative: 'negative'
};
Button.margins = {
  top: 'top',
  bottom: 'bottom'
};